// ===== Packages =====

import React                        from 'react';

// ===== Components =====

import PostPublishingDialog         from '../PostPublishingDialog';

// ===== Enums =====

import {
    POST_PUBLISHING_DIALOG_MODE,
}                                   from '../../enums';

type Props = React.ComponentProps<typeof PostPublishingDialog>;

function PostAccessDialog(props: Props): JSX.Element {
    return (
        <PostPublishingDialog
            {...props}
            mode={POST_PUBLISHING_DIALOG_MODE.access}
        />
    );
}

export default PostAccessDialog;
